import { render, staticRenderFns } from "./baseConfirm.vue?vue&type=template&id=3b2724e7&scoped=true"
import script from "./baseConfirm.vue?vue&type=script&lang=js"
export * from "./baseConfirm.vue?vue&type=script&lang=js"
import style0 from "./baseConfirm.vue?vue&type=style&index=0&id=3b2724e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_cache-loader@4.1.0_webpack@4.47.0__css-load_163004cd90115b55449e6d2350f1be1c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2724e7",
  null
  
)

export default component.exports